import styles from './styles.module.scss';
import LanscapeWarning from '../../assets/images/LandscapeWarning.svg';

export const LandscapeWarning = () => {
  return (
    <div className={styles.overlay}>
        <img src={LanscapeWarning} alt="Поверните телефон" className={styles.image} />
    </div>
  );
};
